import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Target Type
export const typeList = (params = '') => Http.get(`/marketing-case-types${serialize(params)}`)
export const typeCreate = (params = '') => Http.post('/marketing-case-types', params)
export const typeByID = (params = '') => Http.get(`/marketing-case-types/${params}`)
export const typeUpdate = (params = '') => Http.put(`/marketing-case-types/${params.id}`, params)
export const typeDestroy = (params = '') => Http.delete(`/marketing-case-types/${params.id}`)
